import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { ReactNode } from "react";
import { View } from "@-/com.npmjs.react-native";

export function MorphemeInfoPanelSection({
  children,
  title,
}: {
  children: ReactNode;
  title: string;
}) {
  return (
    <View className="border-y border-border bg-surface">
      <View className="h-4 justify-center border-b border-border px-3">
        <Text className="text-[34px] leading-9 text-foreground">{title}</Text>
      </View>
      <View>{children}</View>
    </View>
  );
}
